module.exports = __webpack_public_path__ + "static/img/mobile_tzsm_banner.e4b069b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mobile_tzsm_banner.png
// module id = efhc
// module chunks = 21